"use client";

import { Label } from "@west-tennessee-consulting/ui";
import { Switch } from "@/components/ui/switch";
import type { UseFormSetValue } from "react-hook-form";
import type { DocumentFormData } from "../msp-document-schema";

interface MspDocumentSettingsSectionProps {
  isInternal: boolean;
  isFeatured: boolean;
  setValue: UseFormSetValue<DocumentFormData>;
}

export function MspDocumentSettingsSection({
  isInternal,
  isFeatured,
  setValue,
}: MspDocumentSettingsSectionProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div className="space-y-0.5">
          <Label htmlFor="is_internal">Internal Only</Label>
          <p className="text-sm text-muted-foreground">
            Only visible to employees and admins
          </p>
        </div>
        <Switch
          id="is_internal"
          checked={isInternal}
          onCheckedChange={(checked: boolean) => setValue("is_internal", checked)}
        />
      </div>

      <div className="flex items-center justify-between">
        <div className="space-y-0.5">
          <Label htmlFor="is_featured">Featured</Label>
          <p className="text-sm text-muted-foreground">Show prominently in lists</p>
        </div>
        <Switch
          id="is_featured"
          checked={isFeatured}
          onCheckedChange={(checked: boolean) => setValue("is_featured", checked)}
        />
      </div>
    </div>
  );
}
